export const footerLinks = [
  {
    id: 1,
		name: 'Terms of use',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 2,
		name: 'privacy',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 3,
		name: 'Sitemap',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 4,
		name: 'Brokers',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 5,
		name: 'Tata Group',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 6,
		name: 'AIG',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 7,
		name: 'Chartis',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 8,
		name: 'Tata AIA Life Insurance',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 9,
		name: 'IRDA CEW',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 10,
		name: 'US Visitor Visa',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 11,
		name: 'Tata Medical Center',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
  {
    id: 12,
		name: 'Insurance Institute of India',
    link:
      'https://www.tataaig.com/content/dam/tagic/PDF/CycloneClaimSettlement/hudhud-cyclone-claim-settlement-status.pdf',
  },
];

